<template>
  <a-select
    v-model="selected"
    :label-in-value="labelInValue"
    :options="options"
    :disabled="disabled"
    :show-search="showSearch"
    :filter-option="filterOption"
    
    :style="{width: width + 'px', height: height + 'px'}"
    @change="change"
  ></a-select>
</template>

<script>
export default {
  name: 'SimpleSelect',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Object, String, Number]
    },
    width: {
      type: Number,
      default: 114
    },
    height: {
      type: Number,
      default: 32
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelInValue: {
      type: Boolean,
      default: true
    },
    autoSelect: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    filterOption: {
      type: [Function, Boolean],
      default: false
    }
  },
  data () {
    return {
      selected: this.labelInValue ? undefined : ''
    }
  },
  mounted () {
    if (this.value) this.selected = this.value
    else if (this.autoSelect && this.options && this.options.length) {
      this.selected = this.labelInValue ? this.options[0] : this.options[0].key
      if (this.labelInValue) this.$emit('input', { label: this.options[0].label, value: this.options[0].key })
      else this.$emit('input', this.options[0].key)
    }
  },
  methods: {
    change (value) {
      if (this.labelInValue) this.$emit('input', { label: value.label, value: value.key })
      else this.$emit('input', value)
    }
  },
  watch: {
    value: {
      handler (v, ov) {
        this.selected = v
      },
      deep: true
    }
  }
}
</script>
